import {
  ACTION_DELETE_NOTIFICATION__REQUEST,
  ACTION_DELETE_NOTIFICATION__SUCCESS,
  ACTION_DELETE_NOTIFICATION__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_NOTIFICATION__REQUEST:
    case ACTION_DELETE_NOTIFICATION__SUCCESS:
      return null;

    case ACTION_DELETE_NOTIFICATION__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
